import { render, staticRenderFns } from "./member_invite.vue?vue&type=template&id=3a08114b&"
import script from "./member_invite.vue?vue&type=script&lang=js&"
export * from "./member_invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports